import { notification } from '@surecompanies/core_components'
import { useMutation } from '@tanstack/react-query'
import { extractApiErrorMessage } from 'helpers/api-error-message'
import { createDemoCustomer } from '../api/demo-customer.api'
import { DemoCustomerStep1Data } from '../demoCustomer.schema'
import { CreateDemoCustomerResponse } from '../types'

export default function useCreateDemoCustomer() {
  return useMutation<CreateDemoCustomerResponse, Error, DemoCustomerStep1Data>({
    mutationFn: createDemoCustomer,
    mutationKey: ['createDemoCustomer'],
    onSuccess: (data) => {
      // data.name is the full prefixed name e.g. "ZZ - DEMO - Acme Corp"
      const displayName = data.name.replace(/^ZZ - DEMO - /i, '')
      notification.success({
        message: `Demo company "${displayName}" created successfully`,
      })
    },
    onError: (error: any) => {
      notification.error({
        message: 'Error creating demo company',
        description: extractApiErrorMessage(error),
        duration: 60,
      })
    },
  })
}
